import styled from '@emotion/styled';
import { Form } from 'antd';

import { css } from 'config/emotionCss';

import colors from 'config/theme/colors';

export const containerStyle = css`
  display: flex !important;
  gap: 10px !important;
  justify-content: center !important;
  
  margin: 12px 0;
`;

export const errorStyle = css`
  color: ${colors['@error-color']};
  font-weight: 500;
  margin: 0;
`;

export const Wrapper = styled(Form)`
  position: relative;
  top: 100px;
  
  width: 520px;
  margin: 0 auto;
  
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const Footer = styled.div`
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid ${colors['@border-light-grey']};
`;

export const VerifyContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  
  & > .title {
    font-size: 18px;
    font-weight: 600 !important;
    
    margin-bottom: 0;  
  }
`;

export const StyledInput = styled.input`
  text-align: center !important;

  width: 32px !important;
  height: 32px;

  border-radius: 8px;
  border: 1px solid ${colors['@btn-default-border']};
`;
